/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Why_Released_ValueInputs */

const en_landing_why_released_value = /** @type {(inputs: Landing_Why_Released_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`September 30, 2026`)
};

const zh_landing_why_released_value = /** @type {(inputs: Landing_Why_Released_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`2026 年 9 月 30 日`)
};

/**
* | output |
* | --- |
* | "September 30, 2026" |
*
* @param {Landing_Why_Released_ValueInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_why_released_value = /** @type {((inputs?: Landing_Why_Released_ValueInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Why_Released_ValueInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_why_released_value(inputs)
	return zh_landing_why_released_value(inputs)
});
export { landing_why_released_value as "landing.why.released_value" }